import { Button, Tooltip } from '@mui/material';
import { FC, ElementType } from 'react';

interface TableActionButtonProps {
    onClick: any;
    IconComponent: ElementType;
    displayOption?: boolean;
    iconColor?: string;
    disabled?: boolean;
    tooltip?: string;
    testID?: string;
}

const TableActionButton: FC<TableActionButtonProps> = ({
    onClick,
    IconComponent,
    disabled = false,
    displayOption = true,
    iconColor,
    tooltip,
    testID
}) => {
    if (!displayOption) return null;

    const button = (
        <Button
            variant="outlined"
            disabled={disabled}
            data-testid={testID}
            sx={{
                minWidth: 35,
                minHeight: 35,
                padding: 0,
                borderRadius: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: '#384A52',
                borderColor: '#D9D9D9',
                '&:hover': {
                    backgroundColor: 'white'
                }
            }}
            onClick={onClick}
        >
            <IconComponent sx={{ color: iconColor }} />
        </Button>
    );

    if (!tooltip) return button;

    return (
        <Tooltip title={tooltip} arrow placement="top">
            <span>{button}</span>
        </Tooltip>
    );
};

export default TableActionButton;
